module.exports = __webpack_public_path__ + "img/t3.ef9d56f4.jpg";